import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data31 from '../../data/data31.json'
import ArticleList from '../../Components/ArticleList';

const InstitutionalNews: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>机构动态</h1>
                <ArticleList dataId="31" data={data31 as any} />
            </div>
        } />
    );
};

export default InstitutionalNews;